import '../../../frontend/src/App.css';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../config/axiosConfig';
import { Form } from 'react-bootstrap';

function SignIn() {
    const [values, setValues] = useState({
        username: '',
        password: '',
    });

    const [message, setMessage] = useState('');
    const navigate = useNavigate(); // Hook to programmatically navigate between routes

    api.defaults.withCredentials = true;

    // Check if the user is already authenticated
    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                const response = await api.get('/auth/check'); // Replace with your endpoint to verify authentication
                if (response.data.authenticated) {
                    navigate('/admin'); // Redirect if already authenticated
                }
            } catch (error) {
                console.log('User is not authenticated', error.response || error.message);
            }
        };
        checkAuthentication();
    }, [navigate]);

    const handleChange = (e) => {
        // Update state based on the input's name attribute
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post('/signIn', values); // API call to log in user
            setMessage('LogIn successful!');

            // Save user data to local storage (or context)
            localStorage.setItem('user', JSON.stringify(response.data.user));

            // Delay for 2 seconds before redirecting to admin
            setTimeout(() => {
                navigate('/admin');
            }, 2000);
        } catch (error) {
            setMessage(
                error.response
                    ? error.response.data.message || 'Error occurred during Login'
                    : 'Server error, please try again later.'
            );
            console.error('Error during login:', error.response || error.message);
        }
    };

    return (
        <>
            <div className="App register-page">
                <Form onSubmit={handleSubmit}>
                    <div className="loginform px-4 py-5">
                        <h3 className="text-center">Sign In</h3>
                        {message && <div className="alert alert-info text-center">{message}</div>}
                        <div className="my-3">
                            <label>Username</label>
                            <input
                                name="username"
                                type="text"
                                onChange={handleChange}
                                value={values.username}
                                required
                                className="m-0"
                            />
                        </div>
                        <div className="my-3">
                            <label>Password</label>
                            <input
                                name="password"
                                type="password"
                                onChange={handleChange}
                                value={values.password}
                                required
                                className="m-0"
                            />
                        </div>
                        <div className="text-center">
                            <button type="submit">Sign In</button>
                        </div>
                        <div className="text-center">
                            Create an account{' '}
                            <Link to="/signUp" className="text-center">
                                Sign Up
                            </Link>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
}

export default SignIn;
